<template>
   <v-container class="main-container">
        <div class="main-content-area">
        
            <!--【パンくずリスト】-->
            <v-row justify="center">
              <v-col cols="8">
                <v-breadcrumbs :items="items">
                   <template v-slot:item="{ item }">
                    <v-breadcrumbs-item
                      :href="item.href"
                      :disabled="item.disabled"
                    >
                      {{ item.text }}
                    </v-breadcrumbs-item>
                  </template>
                  <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                  </template>
                </v-breadcrumbs>
              </v-col>
            </v-row>
       
            <!--【ヘルプ記事】-->
      		<v-row justify="center">
    		    <v-col cols="8">
      				<v-card class="mx-auto mt-2 mb-4 py-6 px-6" outlined>
      				  <v-card-title v-text="article.title"></v-card-title>
    				    <v-card-subtitle v-text="article.article_details"></v-card-subtitle>
              </v-card>
      			</v-col>
      		</v-row>
  			
        </div>
    </v-container>
</template>

<script>
  export default {
    props: {
        article: {
          type: Object,
        }
    },  
    data: () => ({
      　// パンくずリスト
        items: [
          {
            text: 'ヘルプ記事検索',
            disabled: false,
            href: '/documents/help',
          },
          {
            text: 'title',
            disabled: true,
            href: '',
          },
        ],
    }),
    // 選択されたヘルプ記事のタイトルをパンくずリスト2番目に表示
    mounted() {
      this.items[1].text = this.article.title;
    },
};
</script>

<style scoped>
    .main-container {
        margin-right: 0px !important;
        margin-left: 0px !important;
        max-width: none !important;
        height: 100% !important;
    }
    .main-content-area {
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }
</style>
